// extracted by mini-css-extract-plugin
export default {"outline_btn":"Button_outline_btn__xqXs5","full_width":"Button_full_width__UJTJi","solid_btn":"Button_solid_btn__HTWn3","disable":"Button_disable__7N5j2"};